import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FeaturesPage = lazy(() => import('../pages/features/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const TemplatesPage = lazy(() => import('../pages/templates/page'));
const ToolsPage = lazy(() => import('../pages/tools/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const BookGeneratorPage = lazy(() => import('../pages/dashboard/book-generator/page'));
const BookTemplatesPage = lazy(() => import('../pages/dashboard/book-templates/page'));
const MarketingCreatorPage = lazy(() => import('../pages/dashboard/marketing-creator/page'));
const MarketingEditorPage = lazy(() => import('../pages/dashboard/marketing-creator/editor/page'));
const SocialMediaPage = lazy(() => import('../pages/dashboard/social-media/page'));
const EmailCampaignsPage = lazy(() => import('../pages/dashboard/email-campaigns/page'));
const EbookWritingPage = lazy(() => import('../pages/dashboard/ebook-writing/page'));
const SalesFlyersPage = lazy(() => import('../pages/dashboard/sales-flyers/page'));
const MarketingAdsPage = lazy(() => import('../pages/dashboard/marketing-ads/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AIEbookGeneratorPage = lazy(() => import('../pages/dashboard/ai-ebook-generator/page'));

import AIParametersPage from '../pages/dashboard/ai-parameters/page'
import BookLayoutEditor from '../pages/dashboard/book-layout-editor/page';

// Dashboard Pages
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const AIEbookGenerator = lazy(() => import('../pages/dashboard/ai-ebook-generator/page'));
const AIParameters = lazy(() => import('../pages/dashboard/ai-parameters/page'));
const BookGenerator = lazy(() => import('../pages/dashboard/book-generator/page'));
const BookEditor = lazy(() => import('../pages/dashboard/book-editor/page'));
const BookTemplates = lazy(() => import('../pages/dashboard/book-templates/page'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

const DashboardBookLayoutEditor = lazy(() => import('../pages/dashboard/book-layout-editor/page'));
const DashboardBookLayoutPreview = lazy(() => import('../pages/dashboard/book-layout-preview/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<LoadingSpinner />}><HomePage /></Suspense>
  },
  {
    path: '/about',
    element: <Suspense fallback={<LoadingSpinner />}><AboutPage /></Suspense>
  },
  {
    path: '/features',
    element: <Suspense fallback={<LoadingSpinner />}><FeaturesPage /></Suspense>
  },
  {
    path: '/pricing',
    element: <Suspense fallback={<LoadingSpinner />}><PricingPage /></Suspense>
  },
  {
    path: '/contact',
    element: <Suspense fallback={<LoadingSpinner />}><ContactPage /></Suspense>
  },
  {
    path: '/help',
    element: <Suspense fallback={<LoadingSpinner />}><HelpPage /></Suspense>
  },
  {
    path: '/reviews',
    element: <Suspense fallback={<LoadingSpinner />}><ReviewsPage /></Suspense>
  },
  {
    path: '/templates',
    element: <Suspense fallback={<LoadingSpinner />}><TemplatesPage /></Suspense>
  },
  {
    path: '/tools',
    element: <Suspense fallback={<LoadingSpinner />}><ToolsPage /></Suspense>
  },
  {
    path: '/auth/login',
    element: <Suspense fallback={<LoadingSpinner />}><LoginPage /></Suspense>
  },
  {
    path: '/auth/register',
    element: <Suspense fallback={<LoadingSpinner />}><RegisterPage /></Suspense>
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/dashboard/ai-ebook-generator',
    element: <AIEbookGenerator />,
  },
  {
    path: '/dashboard/ai-parameters',
    element: <AIParameters />,
  },
  {
    path: '/dashboard/book-generator',
    element: <BookGenerator />,
  },
  {
    path: '/dashboard/book-layout-editor',
    element: <DashboardBookLayoutEditor />,
  },
  {
    path: '/dashboard/book-layout-preview',
    element: <DashboardBookLayoutPreview />,
  },
  {
    path: '/dashboard/book-editor',
    element: <BookEditor />,
  },
  {
    path: '/dashboard/book-templates',
    element: <BookTemplates />,
  },
  {
    path: '/dashboard/marketing-creator',
    element: <MarketingCreatorPage />
  },
  {
    path: '/dashboard/marketing-creator/editor',
    element: <MarketingEditorPage />
  },
  {
    path: '/dashboard/social-media',
    element: <SocialMediaPage />
  },
  {
    path: '/dashboard/email-campaigns',
    element: <EmailCampaignsPage />
  },
  {
    path: '/dashboard/ebook-writing',
    element: <Suspense fallback={<LoadingSpinner />}><EbookWritingPage /></Suspense>
  },
  {
    path: '/dashboard/sales-flyers',
    element: <Suspense fallback={<LoadingSpinner />}><SalesFlyersPage /></Suspense>
  },
  {
    path: '/dashboard/marketing-ads',
    element: <Suspense fallback={<LoadingSpinner />}><MarketingAdsPage /></Suspense>
  },
  {
    path: '/checkout',
    element: <Suspense fallback={<LoadingSpinner />}><CheckoutPage /></Suspense>
  },
  {
    path: '/admin',
    element: <Suspense fallback={<LoadingSpinner />}><AdminPage /></Suspense>
  },
  {
    path: '*',
    element: <Suspense fallback={<LoadingSpinner />}><NotFoundPage /></Suspense>
  }
];

export default routes;
